import React from 'react';
import LobbyingWizard from '../components/community/LobbyingWizard';
import CapitalTenderPortal from '../components/community/CapitalTenderPortal';
import { PARTNER_TYPES } from '../data/partners';

const CommunityInvestment = () => {
    return (
        <div className="min-h-screen bg-slate-50 py-12 px-4 md:px-8">
            <div className="max-w-7xl mx-auto">
                <header className="text-center mb-16">
                    <h1 className="text-4xl font-extrabold text-slate-900 mb-4">Community Investment</h1>
                    <p className="text-xl text-slate-600 max-w-2xl mx-auto">
                        Incubate, Finance, and Scale Alumni Projects through unified advocacy and unbiased capital access.
                    </p>
                </header>

                <div className="grid lg:grid-cols-2 gap-12">
                    
                    {/* SECTION 1: LOBBYING */}
                    <div>
                        <div className="mb-8">
                            <h2 className="text-2xl font-bold text-slate-800 mb-4">1. Policy & Advocacy</h2>
                            <p className="text-slate-600">
                                Businesses seek to influence legislation, taxation, and regulation. 
                                Aulice aggregates these needs to advocate for the ecosystem.
                            </p>
                        </div>
                        <LobbyingWizard />
                    </div>

                    {/* SECTION 2: CAPITAL TENDER */}
                    <div>
                        <div className="mb-8">
                            <h2 className="text-2xl font-bold text-slate-800 mb-4">2. The Capital Stack</h2>
                            <p className="text-slate-600 mb-4">
                                Aulice cooperates with four tiers of financial institutions. We use a <strong>Tender Bidding</strong> model to ensure unbiased decisions.
                            </p>
                            
                            {/* Educational Accordion / Cards for Partner Types */}
                            <div className="grid grid-cols-1 gap-4 mb-6">
                                {PARTNER_TYPES.map(type => (
                                    <div key={type.id} className="bg-white p-4 rounded border-l-4 border-blue-500 shadow-sm">
                                        <h4 className="font-bold text-slate-900">{type.label}</h4>
                                        <p className="text-xs text-slate-500 mt-1">{type.description}</p>
                                        <p className="text-xs text-blue-700 mt-2 font-medium">Use Case: {type.fit}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <CapitalTenderPortal />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default CommunityInvestment;